import { useTranslation } from '@mint-lib/i18n';
import { Close } from '@mint-lib/icons';
import {
  Avatar,
  AvatarFallback,
  Button,
  TruncateText,
  typographyVariants,
} from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

type Props = {
  firstName?: string | null;
  lastName?: string | null;
  label: string;
  onRemove?: () => void;
};

export const InvitedUser = ({
  firstName,
  lastName,
  label,
  onRemove,
}: Props) => {
  const { t } = useTranslation('@mint-lib/ai-chat');

  return (
    <li className="flex h-10 flex-row items-center justify-between gap-2">
      <div className="flex min-w-0 flex-row items-center gap-2">
        <Avatar size="small" className="shrink-0">
          <AvatarFallback
            firstName={firstName ?? undefined}
            lastName={lastName ?? undefined}
          />
        </Avatar>
        <TruncateText>
          <p
            className={cn(
              'min-w-0',
              typographyVariants({ variant: 'bodyLong01' }),
            )}
          >
            {label}
          </p>
        </TruncateText>
      </div>

      {onRemove && (
        <Button
          variant="plain"
          size="small"
          className="shrink-0"
          aria-label={t('Remove {{name}}', { name: label })}
          data-dd-action-name="Knowledge base: remove invited user"
          onClick={onRemove}
        >
          <Close />
        </Button>
      )}
    </li>
  );
};
